import { Check, Phone, Plus, User, Shield, FileText } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { notify, usPhoneFormatValid, userAccessToken } from "../../helpers";
import { getSMSLimitData } from "../../services/message";
import { ThreeDots } from "react-loader-spinner";
import { createOrder, fetchScanList } from "../../services/order";
import { getPrescribers, getPrescriberSpeciality } from "../../services/users";
import Spacing from "../Spacing";
import { Drawer } from 'vaul';


export default function CreateOrderModal(props) {
  const {
    last_name = "",
    first_name = "",
    phone = "",
    message_type = "Single",
    patient_id,
    insurance_name,
    insurance_code,
    zip_code,
    account_id,
    user_id,
    location_id,
    activeModal,
    setActiveModal = () => {},
    setSmsLimit = () => {},
    previousScrollPosition = 0,
  } = props;

  const [formData, setFormData] = useState({
    user_id:user_id,
    account_id: account_id,
    notification_type: message_type,
    message_body: "",
    receiver_address: phone,
    location_id: location_id,
    exam_reason: "",
    zipcode: zip_code || "",
    icd10: "",
    speciality : "",
    scheduling_notes: "",
    additional_notes: "",
    group_number:  "",   
    insurance_plan: insurance_name || "",  
    policy_number : insurance_code || "",   
    medmo_scan_id : null
  });
  const [uniqueModalities, setUniqueModalities] = useState([]);
  const [uniqueBodyParts, setUniqueBodyParts] = useState([]);
  const [bodyParts, setBodyParts] = useState([]);
  const [options1, setOptions1] = useState([]);
  const [selectedModality, setSelectedModality] = useState("");
  const [selectedPrescriber, setSelectedPrescriber] = useState("");
  const [specility, setSpecility] = useState([]);
  const [selectedBodyPart, setSelectedBodyPart] = useState("");
  const [selectedScanOption, setSelectedScanOption] = useState("");
  const [file, setFile] = useState(null);
  const [fileTypeId, setFileTypeId] = useState(null); // File type ID
  const [loading, setLoading] = useState(false); 
  const [fileError, setFileError] = useState(false); // State for error
  const [scanList, setScanData] = useState([]);
  const [prescribersList, setPrescribersList] = useState([]);
  const dropdownRef = useRef(null);

  const fetchScanData = async () => {
    const response = await fetchScanList();
    if (response) {
      const generateScanData = response.data
      setScanData(generateScanData);
    }
  };

  const fetchPrescribersData = async (account_id, location_id) => {
    const response = await getPrescribers(account_id, location_id);
    if (response) {
      const generatePrescriberData = response.data
      setPrescribersList(generatePrescriberData);
    }
  };

  useEffect(() => {
    fetchScanData();
  }, []);

  useEffect(() => {
    fetchPrescribersData(account_id, location_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Extract unique modalities from scanList
    const modalities = [...new Set(scanList.map(scan => scan.Modality))];
    // const bodyParts = [...new Set(scanList.map(scan => scan.BodyPart))];
    setUniqueModalities(modalities);
    // setUniqueBodyParts(bodyParts);
  }, [scanList]);
  

  useEffect(() => {
    // Update body parts based on the selected modality
    if (selectedModality) {
      const filteredBodyParts = scanList
        .filter(scan => scan.Modality === selectedModality)
        .map(scan => scan.BodyPart);
      setBodyParts([...new Set(filteredBodyParts)]);
      setSelectedBodyPart(""); // Reset body part selection
      setSelectedScanOption(""); // Reset option scan part selection
      setOptions1([]); // Reset options1 selection
    } else {
      setBodyParts([]);
      setOptions1([]);
    }
  }, [selectedModality, scanList]);


  useEffect(() => {
    // Update options1 based on selected modality and body part
    if (selectedModality && selectedBodyPart) {
      const filteredOptions1 = [...new Set(
        scanList
          .filter(scan => scan.Modality === selectedModality && scan.BodyPart === selectedBodyPart)
          .map(scan => scan.Option1)
          .filter(option => option !== "") // Exclude empty options
      )];
      setOptions1(filteredOptions1);
    } else {
      setOptions1([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedModality, selectedBodyPart]);



  const fetchSpecilityData = async (prescriber) => {
    const response = await getPrescriberSpeciality(prescriber);
    if (response) {
      const generatePrescriberSpecilityData = response.data
      setSpecility(generatePrescriberSpecilityData);
    }
  };


  useEffect(() => {
    // Update body parts based on the selected modality
    if (selectedPrescriber) {
      fetchSpecilityData(selectedPrescriber) 
    } else {
     setSpecility([]);
    }
  }, [selectedPrescriber]);


  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    
    if (selectedFile && selectedFile.type !== "application/pdf") {
      setFileError(true); // Show error if the file is not a PDF
      setFile(null);      // Reset the file state
    } else {
      setFileError(false); // Clear the error if the file is a PDF
      setFile(selectedFile);
    }
  };

  const handleFileTypeChange = (e) => {
      setFileTypeId(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
  };

  const getSMSLimit = async() => {
    const result = await getSMSLimitData(account_id);
    if (result) {
      setSmsLimit(result?.data);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (fileError) {
      notify("error", "Please upload a valid PDF file.");
      setLoading(false); 
      return;
    }

    if (usPhoneFormatValid(formData.receiver_address) === null) {
      notify("error", "Invalid phone number");
      setLoading(false);
    } else {
      try {
        // Disable the submit button
        e.target.disabled = true;

        const selectedScan = scanList.find(scan => 
          scan.Modality === selectedModality && 
          scan.BodyPart === selectedBodyPart &&
          scan.Option1 === selectedScanOption
        );
        
        const medmo_scan_id = selectedScan ? selectedScan.MedmoScanID : null;

        const formDataObj = new FormData();
        formDataObj.append("medmo_scan_id", medmo_scan_id);
        formDataObj.append("icd10", formData.icd10);
        formDataObj.append("exam_reason", formData.exam_reason);
        formDataObj.append("scheduling_notes", formData.scheduling_notes);
        formDataObj.append("additional_notes", formData.additional_notes);
        formDataObj.append("insurance_plan", formData.insurance_plan);
        formDataObj.append("policy_number", formData.policy_number);
        formDataObj.append("group_number", formData.group_number);
        formDataObj.append("zipcode", formData.zipcode);
        formDataObj.append("speciality", formData.speciality)
        formDataObj.append("file_type_id", 1); // Add file_type_id
        if (file) {
          formDataObj.append("file", file);
        }

        const response = await createOrder(patient_id, selectedPrescriber, location_id, formDataObj);

        if (response.status === 200) {
          setFormData({
            ...formData,
            message_body: "",
          });


        // const response = await axios.post(
        //   Config.notificationServerUrl + "/message-transaction/regular-create",
        //   formData,
        //   {
        //     headers: {
        //       "Content-Type": "application/json",
        //       accept: "application/json",
        //       Authorization: `Bearer ${
        //         userAccessToken()
        //       }`,
        //     },
        //   }
        // );
      //   const response = {
      //     data: {
      //       status: 'success',
      //       receiver_address: '00000000'
      //   }
      // };


          // console.log("---->>>",response)
          // console.log("--->>> reponse data",response.data)
          // console.log("--->>> reponse status",response.status)
          // debugger
          notify("success", "Order created successfully!");
          
          // Re-enable the submit button
          e.target.disabled = false;
          handleDrawerClose();
          setTimeout(() => {
            getSMSLimit();
          }, 5000);
        }
        else {
          notify("error", `Order creation failed with status: ${response.status}`);
        }
      } catch (error) {
        notify("error", `Order creation failed: ${error.message}`);

        // Re-enable the submit button on error as well
        e.target.disabled = false;
      }finally {
        setLoading(false); // Stop loading after request completes
      }
    }
  };

  const handleDrawerClose = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  useEffect(() => {
    setFormData({
      ...formData,
      location_id: location_id,
      account_id: account_id,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location_id, account_id]);

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Create Order</Drawer.Title>
            <Drawer.Description className="sr-only">Create order  of a parient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_1 docpro_modal_lg">
              <div className="docpro_modal">
                <h2 className="docpro_fs_24 docpro_mb_0">Create an order</h2>
                <Spacing lg="20" sm="20" />
                <form onSubmit={handleSubmit}>
                  <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2 input">
                    <div className="docpro_grid_item">
                      {(last_name + first_name).length >= 2 && (
                        <>
                          <label className="docpro_fw_500 docpro_primary_color">
                            Patient Name
                          </label>
                          <div className="docpro_form_field_with_icon">
                            <input
                              name="full_name"
                              type="text"
                              defaultValue={last_name + " " + first_name}
                              className="docpro_form_field size_lg"
                              readOnly
                            />
                            <User
                              width={20}
                              height={20}
                              className="docpro_form_field_icon"
                            />
                            <Check
                              width={20}
                              height={20}
                              className="docpro_form_field_icon"
                            />
                          </div>
                        </>
                      )}
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Patient Number <span className="docpro_red_color">*</span>
                      </label>
                      <div className="docpro_form_field_with_icon_group">
                        <select className="docpro_form_field size_lg">
                          <option value="1">+1</option>
                        </select>
                        <input
                          type="text"
                          name="receiver_address"
                          className="docpro_form_field size_lg us_phone"
                          onChange={handleChange}
                          value={phone.length > 9 ? phone : formData.receiver_address}
                          readOnly={!phone.length > 9}
                          minLength={9}
                          maxLength={16}
                          required
                        />
                        <Phone
                          width={20}
                          height={20}
                          className="docpro_form_field_icon"
                        />
                        <Check
                          width={20}
                          height={20}
                          className="docpro_form_field_icon"
                        />
                      </div>
                    </div>
                  
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Insurance Plan
                      </label>
                      <div className="docpro_form_field_with_icon">
                        <input
                          name="insurance_plan"
                          type="text"
                          defaultValue={insurance_name}
                          className="docpro_form_field size_lg"
                          readOnly
                        />
                        <Shield
                          width={20}
                          height={20}
                          className="docpro_form_field_icon"
                        />
                        <Check
                          width={20}
                          height={20}
                          className="docpro_form_field_icon"
                        />
                      </div>
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Policy Number
                      </label>
                      <div className="docpro_form_field_with_icon">
                        <input
                          name="policy_number"
                          type="text"
                          defaultValue={insurance_code}
                          className="docpro_form_field size_lg"
                          readOnly
                        />
                        <FileText
                          width={20}
                          height={20}
                          className="docpro_form_field_icon"
                        />
                        <Check
                          width={20}
                          height={20}
                          className="docpro_form_field_icon"
                        />
                      </div>
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Exam Reason <span className="docpro_red_color">*</span>
                      </label>
                      <div>
                        <input
                          name="exam_reason"
                          type="text"
                          className="docpro_form_field size_lg"
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Zipcode <span className="docpro_red_color">*</span>
                      </label>
                      <div>
                        <input
                          name="zipcode"
                          type="text"
                          className="docpro_form_field size_lg"
                          defaultValue={zip_code}
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Group Number
                      </label>
                      <div>
                        <input
                          name="group_number"
                          type="text"
                          className="docpro_form_field size_lg"
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="docpro_grid_item">
                      <div className="docpro_label_group">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Modality <span className="docpro_red_color">*</span>
                        </label>
                      </div>
                      <select
                        className="docpro_form_field size_lg"
                        onChange={(e) => setSelectedModality(e.target.value)}
                        required
                      >
                        <option value="">Select Modality</option>

                        {uniqueModalities.map((modality, index) => (
                          <option key={index} value={modality}>
                            {modality}
                          </option>
                        ))}
                      </select>
                    </div>

                    {selectedModality && (
                      <div className="docpro_grid_item">
                        <div className="docpro_label_group">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Body Part <span className="docpro_red_color">*</span>
                          </label>
                        </div>
                        <select
                          className="docpro_form_field size_lg"
                          onChange={(e) => setSelectedBodyPart(e.target.value)}
                          required
                        >
                          <option value="">Select Body Part</option>
                          {bodyParts.map((bodyPart, index) => (
                            <option key={index} value={bodyPart}>
                              {bodyPart}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    
                    {selectedModality && selectedBodyPart && options1.length > 0 && (
                      <div className="docpro_grid_item">
                        <div className="docpro_label_group">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Scan Option <span className="docpro_red_color">*</span>
                          </label>
                        </div>
                        <select
                          className="docpro_form_field size_lg"
                          onChange={(e) => setSelectedScanOption(e.target.value)}
                          name="scan_option"
                          required
                        >
                          <option value="">Select Scan Option</option>
                          {options1.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className="docpro_grid_item">
                      <div className="docpro_label_group">
                        <label className="docpro_fw_500 docpro_primary_color">
                        Prescriber <span className="docpro_red_color">*</span>
                        </label>
                      </div>
                      <select
                        className="docpro_form_field size_lg"
                        name="prescriber"
                        onChange={(e) => setSelectedPrescriber(e.target.value)}
                        required
                      >
                        <option value="">Select Prescriber</option>

                        {prescribersList.map((prescriber) => (
                          <option key={prescriber.id} value={prescriber.id}>
                            {prescriber.first_name + " " + prescriber.last_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {selectedPrescriber && (
                      <div className="docpro_grid_item">
                        <div className="docpro_label_group">
                          <label className="docpro_fw_500 docpro_primary_color">
                          Speciality <span className="docpro_red_color">*</span>
                          </label>
                        </div>
                        <select
                          className="docpro_form_field size_lg"
                          name="speciality"
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Speciality</option>

                          {specility.map((speciality_obj) => (
                            <option key={speciality_obj.id} value={speciality_obj.speciality_name}>
                              {speciality_obj.speciality_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        File Type ID <span className="docpro_red_color">*</span>
                      </label>
                      <div>
                        <input
                          name="file_type_id"
                          type="text"
                          className="docpro_form_field size_lg"
                          required
                          onChange={handleFileTypeChange}
                        />
                      </div>
                    </div> */}

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Upload File
                      </label>
                      <div className='input_file_conatiner'>
                        <label htmlFor="file-upload" className='file_button'>
                          Choose Files
                        </label>
                        <input
                          type="file"
                          id="file-upload"
                          accept=".xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf"
                          className='file_hidden_input'
                          onChange={handleFileChange}
                        />
                        <span className='file_label'>{file ? `${file?.name}` : 'No file chosen'}</span>
                      </div>
                      {fileError && (
                        <p className="docpro_error_message">
                          Please upload a valid PDF file.
                        </p>
                      )}
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        ICD10
                      </label>
                      <div>
                        <input
                          name="icd10"
                          type="text"
                          className="docpro_form_field size_lg"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <Spacing lg="20" sm="20" />

                  <label className="docpro_fw_500 docpro_primary_color">
                    Scheduling Notes
                  </label>
                  <div>
                    <textarea
                      name="scheduling_notes"
                      className="docpro_form_field size_lg"
                      cols="30"
                      rows="5"
                      onChange={handleChange}
                        
                      placeholder="Write your Scheduling Notes here..."
                    ></textarea>
                  </div>
                  <Spacing lg="20" sm="20" />
                  
                  <label className="docpro_fw_500 docpro_primary_color">
                    Additional Notes
                  </label>
                  <div className="docpro_form_field_with_icon">
                    <textarea
                      name="additional_notes"
                      className="docpro_form_field size_lg"
                      cols="30"
                      rows="5"
                      onChange={handleChange}
                      
                      placeholder="Write your Additional Notes here..."
                    ></textarea>
                  </div>
                  <Spacing lg="20" sm="20" />

                  <button
                    type="submit"
                    className="docpro_bordered_btn size_lg width_100 docpro_fw_600 docpro_white_color docpro_filed_btn"
                    disabled={loading} // Disable button while loading
                  >
                    {loading ? (
                    <ThreeDots
                    color="#ffffff"
                    height={20}
                    width={40}
                  />
                    ) : (
                      <>
                        <Plus width={20} height={20} />
                        <span>Create Order</span>
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
